export const redeemContactSupportTemplate =
	"Entered the code perfectly and still having an issue? **Contact support** and make sure to include your access code and purchase details";
